<p [innerHtml]="'sga-reality-check.loggedin' | translate: { elapsedMinutes: data?.elapsedMinutes }"></p>
<div class="obg-sga-reality-check-content">
	<p>{{ "sga-reality-check.header-summary" | translate }}</p>
	<p>
		{{ "sga-reality-check.total-losses" | translate }}
		<span class="obg-sga-reality-check-value" obgSensitiveData> {{ totalLosses }}</span>
	</p>
	<p>
		{{ "sga-reality-check.total-wins" | translate }}
		<span class="obg-sga-reality-check-value" obgSensitiveData> {{ totalWins }}</span>
	</p>
</div>
